















































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import TramiteNovedad from "@/models/tramite/tramite-novedad.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import moment from "moment";
import { Utils } from "@/core/Utils";
@Component
export default class TramiteBeneficiarioNovedadTableComponent extends GenericBTable<
  TramiteNovedad
> {
  @Prop() public title!: string;
  @Prop() public controller!: string;
  @Prop() public action!: string;
  @Prop() public tramiteBeneficiarioId!: string;
  created() {
    this.setupTable();
  }

  setupTable() {
    this.tableConfig.controller = this.controller || "tramitenovedad";
    //this.tableConfig.loading = false;
    this.tableConfig.whereParams = this.getWhereParams();
    this.tableConfig.activeActions = false;
    this.tableConfig.sorting.order = "asc";
    this.tableConfig.loadOnMount = !!this.tramiteBeneficiarioId;
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.include = this.includes;
    this.tableConfig.pagination.perPage = 100;
    this.tableConfig.sorting.field = "order";
    this.tableConfig.detailed = true;
    this.formatColumns();
  }
  getWhereParams() {
    let result = [];
    result.push(`tramiteBeneficiarioId="${this.tramiteBeneficiarioId}"`);
    return result.join("&");
  }
  get includes() {
    let data = [];
    data.push("Institucion");
    return data.join("|");
  }
  formatColumns() {
    let startTime = new BTableColumn("startTime", "Fecha de inicio");
    // startTime.type = BTableColumnType.DateTime;
    startTime.customTemplate = true;
    let dueDate = new BTableColumn("dueDate", "Fecha de vencimiento");
    dueDate.customTemplate = true;
    //dueDate.type = BTableColumnType.DateTime;
    let updatedDate = new BTableColumn("updatedDate", "Ultima actualización");
    //updatedDate.type = BTableColumnType.DateTime;
    updatedDate.customTemplate = true;

    let estado = new BTableColumn("estadoDesc", "Estado", false);
    estado.customTemplate = true;

    this.tableConfig.insertColumns(
      new BTableColumn("order", "Orden"),
      new BTableColumn("titulo", "Título"),
      new BTableColumn("institucionNombre", "Institución"),
      startTime,
      dueDate,
      // updatedDate,
      estado
    );
  }
  @Watch("tramiteBeneficiarioId", { immediate: true })
  onPersonaIdChange(value: number | undefined | null) {
    if (!value) {
      return;
    }
    this.tableConfig.whereParams = this.getWhereParams();

    if (this.tableConfig.reload) {
      this.tableConfig.reload();
    }
  }
  @Watch("tableConfig.data", { deep: true })
  onDataChange(value: TramiteNovedad[]) {
    this.$emit("datos-change", value);
  }
  getValueDate(val: any) {
    return moment(val).format("L");
  }
  getValueTime(val: string) {
    return moment(val).format("LT");
  }

  getEstadoColor(codigo: string) {
    if (codigo === "Abierta") return "light";
    if (codigo === "Creada") return "primary";
    if (codigo === "En proceso") return "info";
    if (codigo === "Completada") return "success";
    if (codigo === "Rechazada") return "danger";
  }
}
